import { setI18n } from "./i18n";

export const setup = () => {
  setI18n();
};
